import { ComponentConfig } from '@measured/puck';
import { colorField, ColorProps } from '../../puck/reusable-props/color';
import { marginFields, MarginProps } from '../../puck/reusable-props/margin';
import { paddingFields, PaddingProps } from '../../puck/reusable-props/padding';
import showComponent, {
  showComponentProps,
} from '../../puck/reusable-props/showComponent';
import { ReduxSelectorProps } from '../../services/constants';
import CustomTooltip from '../../../components/common/tooltip';
import {
  getBorderProps,
  getcurrentDeviceType,
  getMarginStyles,
  getPaddingStyles,
  getQuillEditorText,
} from '../../utils/helper';
import EmailContent from '../../puck/reusable-props/UsersCommonComponent/Email';
import Border, { IBorderValueProps } from '../../puck/reusable-props/Border';

export type UserSectionProps = {
  Header: IEmailShippingProp;
  Email: IEmailShippingProp;
  Shipping: IEmailShippingProp;
  Billing: IEmailShippingProp;
  ShippingMethod: IEmailShippingProp;
  PaymentMethod: IEmailShippingProp;
  border: IBorderValueProps;
} & ColorProps &
  MarginProps &
  PaddingProps &
  showComponentProps;

export interface IEmailShippingProp extends showComponentProps {
  text: string;
  content: string;
}

export interface UserComponentProps extends ReduxSelectorProps {}

export const UserComponent = ({
  useAppSelector,
}: UserComponentProps): ComponentConfig<UserSectionProps> => {
  return {
    label: (
      <CustomTooltip title="user">
        <span>User Details</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,
      Header: {
        type: 'custom',
        label: 'Header',
        render: ({ value, onChange }) => (
          <EmailContent
            value={value}
            onChange={onChange}
            title={'Title'}
            showContent={false}
            id={1}
          />
        ),
      },
      Email: {
        type: 'custom',
        label: 'Email',
        render: ({ value, onChange }) => (
          <EmailContent
            value={value}
            onChange={onChange}
            title={'Email'}
            id={2}
          />
        ),
      },
      Shipping: {
        type: 'custom',
        label: 'Shipping',
        render: ({ value, onChange }) => (
          <EmailContent
            value={value}
            onChange={onChange}
            title={'Shipping Address'}
            id={3}
          />
        ),
      },
      Billing: {
        type: 'custom',
        label: 'Billing',
        render: ({ value, onChange }) => (
          <EmailContent
            value={value}
            onChange={onChange}
            title={'Billing Address'}
            id={4}
          />
        ),
      },
      ShippingMethod: {
        type: 'custom',
        label: 'Shipping Method',
        render: ({ value, onChange }) => (
          <EmailContent
            value={value}
            onChange={onChange}
            title={'Shipping Method'}
            id={5}
          />
        ),
      },
      PaymentMethod: {
        type: 'custom',
        label: 'ShippPayment Methoding',
        render: ({ value, onChange }) => (
          <EmailContent
            value={value}
            onChange={onChange}
            title={'Payment Method'}
            id={6}
          />
        ),
      },
      ...colorField,
      ...marginFields,
      ...paddingFields,
      border: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <Border value={value} onChange={onChange} title="Border" />
        ),
      },
    },
    defaultProps: {
      showComponent: ['desktop', 'tablet', 'mobile'],
      margin: {
        desktop: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        tablet: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        mobile: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
      },
      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '10',
          mobile: '5',
          tablet: '5',
        },
        paddingLeft: {
          desktop: '20',
          mobile: '10',
          tablet: '10',
        },
        paddingRight: {
          desktop: '20',
          mobile: '10',
          tablet: '10',
        },
        paddingTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
      },
      color: {
        backgroundColor: '#FFFFFF',
        hoverColor: '#FFFFFF',
      },
      Email: {
        text: '<h2 style="line-height:1.5;"><span style="font-size: 24px;">Email Address</span></h2>',
        content:
          '<p style="line-height:1.5;"><span style="font-size: 16px;">{email}</span>﻿</p>',

        showComponent: ['desktop', 'tablet', 'mobile'],
      },
      Shipping: {
        text: '<h2 style="line-height:1.5;"><span style="font-size: 24px;">Shipping Address</span></h2>',
        content:
          '<p style="line-height:1.5;"><span style="font-size: 16px;">{first_name} {last_name} </span></p><p><span>{shipping_address1}</span></p><p><span>{shipping_address2}</span></p><p><span>{shipping_city}</span></p><p><span>{shipping_state}</span></p><p><span>{shipping_country}</span></p><p><span>{shipping_zip}</span></p>',
        showComponent: ['desktop', 'tablet', 'mobile'],
      },
      Billing: {
        text: '<h2 style="line-height:1.5;"><span style="font-size: 24px;">Billing Address </span></h2>',
        content:
          '<p style="line-height:1.5;"><span style="font-size: 16px;">{first_name_billing} {last_name_billing}</span></p><p><span>{billing_address1}</span></p><p><span>{billing_address2}</span></p><p><span>{billing_city}</span></p><p><span>{billing_state}</span></p><p><span>{billing_zip}</span></p><p><span>{billing_country}</span>﻿</p>',
        showComponent: ['desktop', 'tablet', 'mobile'],
      },
      PaymentMethod: {
        text: '<h2 style="line-height:1.5;"><span style="font-size: 24px;">Payment Method</span></h2>',
        content:
          '<p style="line-height:1.5;"><span style="font-size: 16px;">Credit Card</span></p>',
        showComponent: [],
      },
      Header: {
        text: '<h1 style="line-height:1.5;"><span style="font-size: 24px;">Customer Information</span></h1>',
        content: '<p></p>',
        showComponent: ['desktop', 'tablet', 'mobile'],
      },
      ShippingMethod: {
        text: '<h2 style="line-height:1.5;"><span style="font-size: 24px;">Shipping Method</span></h2>',
        content:
          '<p style="line-height:1.5"><span style="font-size: 16px;">{shipping_method}</span></p>',
        showComponent: ['desktop', 'tablet', 'mobile'],
      },
      border: {
        deviceType: 'desktop',
        borderBottomLeft: {
          desktop: '0',
          tablet: '0',
          mobile: '0',
        },
        borderBottomRight: {
          desktop: '0',
          tablet: '0',
          mobile: '0',
        },
        borderTopLeft: {
          desktop: '0',
          tablet: '0',
          mobile: '0',
        },
        borderTopRight: {
          desktop: '0',
          tablet: '0',
          mobile: '0',
        },
        borderWidth: {
          desktop: 1,
          tablet: 1,
          mobile: 1,
        },
        borderStyle: {
          desktop: 'border-solid',
          tablet: 'border-solid',
          mobile: 'border-solid',
        },
        borderColor: {
          desktop: '#000000',
          tablet: '#000000',
          mobile: '#000000',
        },
      },
    },
    render: ({
      Header,
      margin,
      padding,
      color,
      showComponent,
      Email,
      Shipping,
      Billing,
      PaymentMethod,
      ShippingMethod,
      editMode,
      border,
    }) => {
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const marginStyles = getMarginStyles(margin, currentDeviceType);
      const data = useAppSelector(state => state);

      return (
        <div className="text-editor-content">
          {showComponent?.includes(currentDeviceType) && (
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                backgroundColor: color?.backgroundColor,
                ...marginStyles,
                ...getPaddingStyles(padding, currentDeviceType),
                ...getBorderProps(border, currentDeviceType),
              }}
              onMouseEnter={event =>
                color?.hoverColor &&
                (event.currentTarget.style.backgroundColor = color.hoverColor)
              }
              onMouseLeave={event =>
                (event.currentTarget.style.backgroundColor =
                  color?.backgroundColor)
              }>
              {Header?.showComponent?.includes(currentDeviceType) ? (
                <div style={{ gridColumn: 'span 2' }}>
                  <div
                    className={`mt-4`}
                    style={{ lineHeight: 1.5 }}
                    dangerouslySetInnerHTML={{ __html: Header?.text }}></div>
                </div>
              ) : null}

              {Email?.showComponent?.includes(currentDeviceType) ? (
                <div style={{ gridColumn: 'span 2' }}>
                  {' '}
                  <div
                    className={`mt-4`}
                    style={{ lineHeight: 1.5 }}
                    dangerouslySetInnerHTML={{ __html: Email?.text }}></div>
                  <div
                    className={`mt-2 `}
                    style={{ lineHeight: 1.5 }}
                    dangerouslySetInnerHTML={{
                      __html: getQuillEditorText(Email?.content, data),
                    }}></div>
                </div>
              ) : null}

              {Shipping?.showComponent?.includes(currentDeviceType) ? (
                <div style={{ gridRow: 'span 2' }}>
                  <>
                    <div
                      className={`mt-4`}
                      style={{ lineHeight: 1.5 }}
                      dangerouslySetInnerHTML={{
                        __html: Shipping?.text,
                      }}></div>
                    <div
                      className={`mt-2 `}
                      style={{ lineHeight: 1.5 }}
                      dangerouslySetInnerHTML={{
                        __html: getQuillEditorText(Shipping?.content, data),
                      }}></div>
                  </>
                </div>
              ) : null}
              {Billing?.showComponent?.includes(currentDeviceType) ? (
                <div style={{ gridRow: 'span 2' }}>
                  <>
                    <div
                      className={`mt-4`}
                      style={{ lineHeight: 1.5 }}
                      dangerouslySetInnerHTML={{ __html: Billing?.text }}></div>
                    <div
                      className={`mt-2 `}
                      style={{ lineHeight: 1.5 }}
                      dangerouslySetInnerHTML={{
                        __html: getQuillEditorText(Billing?.content, data),
                      }}></div>
                  </>
                </div>
              ) : null}

              {ShippingMethod?.showComponent?.includes(currentDeviceType) ? (
                <div style={{ gridRow: 'span 1', gridColumn: 'span 1' }}>
                  <>
                    <div
                      className={`mt-4`}
                      style={{ lineHeight: 1.5 }}
                      dangerouslySetInnerHTML={{
                        __html: ShippingMethod?.text,
                      }}></div>
                    <div
                      className={`mt-2 `}
                      style={{ lineHeight: 1.5 }}
                      dangerouslySetInnerHTML={{
                        __html: getQuillEditorText(
                          ShippingMethod?.content,
                          data,
                        ),
                      }}></div>
                  </>
                </div>
              ) : null}

              {PaymentMethod?.showComponent?.includes(currentDeviceType) ? (
                <div style={{ gridRow: 'span 1', gridColumn: 'span 1' }}>
                  <div
                    className={`mt-4`}
                    style={{ lineHeight: 1.5 }}
                    dangerouslySetInnerHTML={{
                      __html: PaymentMethod?.text,
                    }}></div>
                  <div
                    className={`mt-2 `}
                    style={{ lineHeight: 1.5 }}
                    dangerouslySetInnerHTML={{
                      __html: getQuillEditorText(PaymentMethod?.content, data),
                    }}></div>
                </div>
              ) : null}
            </div>
          )}
        </div>
      );
    },
  };
};
